export const INVITATION_FORM = "invitation";